import { FeatureName, FeaturesCover, FeatureTags } from './styled';
import { getPriceParams } from '../../../Utils/productPageUtils';

import { fireEvent } from '../../../Utils/fireEvent';

export default function index(props) {
  const { productData } = props;
  const features = productData?.features;
  const fireClickedFeatures = () => {
    const { pricingParam, conversionParam } = getPriceParams(productData);
    fireEvent({
      category: 'clicked_know_more_features_pdp',
      id: productData?.id,
      term_id: productData?.offers?.[0]?.term_id,
      offer_id: productData?.offers?.[0]?.offer_id,
      screen_name: 'PDP',
      pricing_param: pricingParam,
      conversion_param: conversionParam,
      trust_tag: productData?.signal?.name || '',
    });
  };

  return (
    <FeaturesCover>
      <FeatureName>Features:</FeatureName>
      <a onClick={fireClickedFeatures} href="#aboutSection" rel="nofollow">
        <FeatureTags
          className="react_ProductSummary_feature_tags"
          dangerouslySetInnerHTML={{
            __html: features,
          }}
        />
      </a>
    </FeaturesCover>
  );
}
